import { provideAppInitializer, inject } from '@angular/core';
import { AppInitializationService } from '../services/app-initialization.service';

export const appInitializerProvider = provideAppInitializer(() => {
  const appInitService: AppInitializationService = inject(
    AppInitializationService
  );
  return appInitService.initializeApp();
});
